import React, { useRef } from 'react';
import classnames from 'classnames';
import numeral from 'numeral';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import shortenNumber from '../../../utils/shortenNumber';
import { BiEventType } from '../../../biLogger/constants';
import LogoutItem from '../../_partials/LogoutItem';
import UserMenuAvatar from './UserMenuAvatar';
import StandardMenu from '../../../Dropdown/Preset/StandardMenu';
import UserLink from '../../../User/Link';
import VerificationReminder from '../../_partials/VerificationReminder';
import FeedbackIcon from '../../../Icons/Feedback';
import CoreIconSmall from '../../../Icons/CoreIconSmall';
import { getMatureToggle, getThemeToggle } from './menuItemHelpers';
import s from './UserMenu.scss';
function formatNumber(number) {
    return number > 999 ? shortenNumber(number, 0, Math.floor) : number;
}
var LoggedInUserMenu = function (_a) {
    var currentUser = _a.currentUser, pointsCount = _a.pointsCount, noteCount = _a.noteCount, csrfToken = _a.csrfToken, canEnableMatureContent = _a.canEnableMatureContent, verificationEmail = _a.verificationEmail, feedbackUrl = _a.feedbackUrl, isUserMenuOpened = _a.isUserMenuOpened, disableThemeSwitcher = _a.disableThemeSwitcher, toggleTheme = _a.toggleTheme, theme = _a.theme, toggleMature = _a.toggleMature, matureContent = _a.matureContent, hasCoreMembership = _a.hasCoreMembership, onToggleUserMenu = _a.onToggleUserMenu;
    var t = useTranslation().t;
    var logoutItemRef = useRef(null);
    var handleLogout = function () {
        logoutItemRef.current && logoutItemRef.current.submit();
    };
    var personalGroupItems = [
        {
            label: (React.createElement("div", { className: s['two-side-label'] },
                React.createElement("span", null, t('siteHeaderMobile.userMenu.notes')),
                noteCount > 0 && (React.createElement("span", { className: s['menu-item-notification'] }, formatNumber(noteCount))))),
            link: URLS.NOTES,
            biData: {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                link_url: URLS.NOTES,
                menu_item: 'notes',
                menu_name: 'profile',
            },
        },
        {
            label: 'Sta.sh',
            link: URLS.STASH,
            biData: {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                menu_item: 'sta.sh',
                menu_name: 'profile',
                link_url: URLS.STASH,
            },
        },
    ];
    var statsGroupItems = [
        {
            label: (React.createElement("div", { className: s['two-side-label'] },
                React.createElement("span", null, t('siteHeaderMobile.userMenu.pointsBalance')),
                React.createElement("span", null, numeral(pointsCount || 0).format('0,0')))),
            link: URLS.POINTS,
            biData: {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                menu_item: 'pointsBalance',
                menu_name: 'profile',
                link_url: URLS.POINTS,
            },
        },
        {
            label: t('siteHeaderMobile.userMenu.myEarnings'),
            link: URLS.EARNINGS,
            biData: {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                menu_item: 'myEarnings',
                menu_name: 'profile',
                link_url: URLS.EARNINGS,
            },
        },
        {
            label: t('siteHeaderMobile.userMenu.myOrderHistory'),
            link: URLS.ORDERS,
            biData: {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                menu_item: 'orderHistory',
                menu_name: 'profile',
                link_url: URLS.ORDERS,
            },
        },
    ];
    var lastGroupItems = [
        !disableThemeSwitcher && getThemeToggle(theme, toggleTheme, t),
        canEnableMatureContent && getMatureToggle(!!matureContent, toggleMature, t),
        {
            label: t('siteHeaderMobile.userMenu.settings'),
            link: URLS.SETTINGS,
            className: s['settings-link'],
            biData: {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                link_url: URLS.SETTINGS,
                menu_item: 'settings',
                menu_name: 'profile',
            },
        },
        {
            label: (React.createElement(LogoutItem, { formRef: logoutItemRef, token: csrfToken, label: t('siteHeaderMobile.userMenu.logOut') })),
            onClick: handleLogout,
            biData: {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                link_url: URLS.LOGOUT,
                menu_item: 'logout',
                menu_name: 'profile',
            },
        },
        feedbackUrl && {
            label: (React.createElement("div", { className: s['two-side-label'] },
                React.createElement("span", null, t('siteHeaderMobile.userMenu.giveUsFeedback')),
                React.createElement(FeedbackIcon, { className: s['feedback-icon'] }))),
            link: feedbackUrl,
            target: '_blank',
        },
    ].filter(function (item) { return item; });
    return (React.createElement(StandardMenu, { lightText: true, className: s['user-menu'], itemClassName: s['user-menu-item'], groupClassName: s['user-menu-group'], withPaddings: false, items: [
            {
                className: s['top-group'],
                items: [
                    {
                        label: (React.createElement("div", { className: s['two-side-label'] },
                            React.createElement(UserLink, { user: currentUser, className: s['user-link'], showSymbol: false }),
                            React.createElement(UserMenuAvatar, { currentUser: currentUser, onToggleUserMenu: onToggleUserMenu, isUserMenuOpened: isUserMenuOpened }))),
                    },
                    {
                        label: (React.createElement("div", { className: classnames(s['two-side-label'], s['buy-core-label']) },
                            React.createElement("span", null, hasCoreMembership
                                ? t('siteHeaderMobile.userMenu.extendCore')
                                : t('siteHeaderMobile.userMenu.buyCoreMembership')),
                            React.createElement("span", null,
                                React.createElement(CoreIconSmall, { className: s['core-icon'] })))),
                        link: URLS.CORE_MEMBERSHIP,
                        biData: {
                            evid: BiEventType.TOP_NAV_MENU_CLICK,
                            menu_item: 'coreMembership',
                            menu_name: 'profile',
                            link_url: URLS.CORE_MEMBERSHIP,
                        },
                    },
                ],
            },
            !verificationEmail && {
                className: s['group'],
                items: personalGroupItems,
            },
            verificationEmail
                ? {
                    label: React.createElement(VerificationReminder, { email: verificationEmail }),
                    className: s['verification-group'],
                }
                : {
                    className: s['group'],
                    items: statsGroupItems,
                },
            {
                className: s['group'],
                items: lastGroupItems,
            },
        ] }));
};
LoggedInUserMenu.displayName = 'LoggedInUserMenu';
export default LoggedInUserMenu;
//# sourceMappingURL=LoggedInUserMenu.js.map